// Clears expansion when a row is removed: a row the last ready load showed is missing from the next ready
// load of the same query, page and page size. It stays mounted through loading, error and empty states, so
// a removal that empties the page or arrives through a refresh still counts. A grouped instance has no
// pager, so it watches every matching row.

import { useEffect, useRef } from 'react'

import { useTable } from '../context'
import { ACTIONS } from '../types'

export const ExpansionWatch = () => {
  const { config, state, status, dispatch, derived } = useTable()
  const last = useRef(null)
  const rows = config.grouped ? derived.matching : derived.pageRows
  useEffect(() => {
    if (status !== 'ready') return
    const ids = rows.map(row => String(row[config.rowKey]))
    const before = last.current
    last.current = {
      ids,
      query: state.query,
      page: state.page,
      pageSize: state.pageSize,
    }
    if (!before || !state.expanded.size) return
    if (
      before.query !== state.query ||
      before.page !== state.page ||
      before.pageSize !== state.pageSize
    )
      return
    const now = new Set(ids)
    if (before.ids.some(id => !now.has(id)))
      dispatch({ type: ACTIONS.expansionClear, reason: 'expansion' })
  })
  return null
}
